import { ICategory } from '@shared/models/category';
import { Product } from '@shared/models/product';

/** System-Warengruppe laut Tenant-Init (sql/bcm-initial-data.sql: 3. Kategorie → id = 3). */
export const KEY_DEPOSIT_PRODUCT_CATEGORY_ID = 3;

/** Legacy-Fallback, falls uniqueId in der DB noch korrekt ist. */
export const KEY_DEPOSIT_PRODUCT_CATEGORY_UNIQUE_ID = 'Schlüsselpfand';

export function isKeyDepositProductCategory(category: ICategory | null | undefined): boolean {
    if (!category) {
        return false;
    }
    if (category.id === KEY_DEPOSIT_PRODUCT_CATEGORY_ID) {
        return true;
    }
    return category.uniqueId === KEY_DEPOSIT_PRODUCT_CATEGORY_UNIQUE_ID;
}

export function filterKeyDepositProducts(products: Product[]): Product[] {
    return (products || []).filter(product => isKeyDepositProductCategory(product.category));
}
